<template>
  <div class="container experience-create">
    <div class="header">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>笔记</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/senior/noteMange' }">编辑笔记</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left"></div>
        <div class="right">
          <el-button plain
                     @click="handleClose">取消</el-button>
          <el-button type="primary"
                     @click="handleSubmit">保存</el-button>
        </div>
      </div>
    </div>
    <div class="main">
      <h3 class="title">笔记编辑</h3>
      <div class="content">
        <el-form :model="dataForm"
                 :rules="rules"
                 ref="dataForm"
                 label-width="130px"
                 class="dataForm left">
          <el-form-item label="文章标题："
                        prop="title">
            <el-input v-model="dataForm.title"
                      placeholder="输入文章标题"></el-input>
            <p class="tip">提示：最多可支持输入60个字符，30个中文字</p>
          </el-form-item>

          <el-form-item label="适合科目："
                        prop="subjects">
            <div class="tag-wrap">
              <el-tag class="subject-item"
                      size="medium"
                      :key="item.id"
                      v-for="item in subjects"
                      closable
                      :disable-transitions="false"
                      @close="handleSubjectRemove(item)">
                ({{item.code}}){{item.name}}
              </el-tag>
              <el-button type="text"
                         @click="handleSubjectChoose">选择科目</el-button>
            </div>
          </el-form-item>
          <el-form-item label="适合专业："
                        prop="majors">
            <div class="tag-wrap">
              <el-tag class="subject-item"
                      size="medium"
                      :key="item.id"
                      v-for="item in majors"
                      closable
                      :disable-transitions="false"
                      @close="handleMajorRemove(item)">
                {{ `${item.name}/${item.code}` }}
              </el-tag>
              <el-button type="text"
                         @click="handleMajorChoose">选择专业</el-button>
            </div>
          </el-form-item>
          <el-form-item label="适合院校："
                        prop="colleges">
            <div class="tag-wrap">
              <el-tag class="subject-item"
                      size="medium"
                      :key="item.id"
                      v-for="item in colleges"
                      closable
                      :disable-transitions="false"
                      @close="handleCollegeRemove(item)">
                ({{item.code}}){{item.name}}
              </el-tag>
              <el-button type="text"
                         @click="handleCollegeChoose">选择院校</el-button>
            </div>
          </el-form-item>

          <el-form-item label="上传图片："
                        prop="picture">
            <el-upload :action="imgUploadUrl"
                       accept=".png,.jpg,.jpeg"
                       list-type="picture-card"
                       :on-preview="handlePictureCardPreview"
                       :on-remove="handleRemove"
                       :on-success="handleSuccess"
                       :file-list="fileList">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="上传资料："
                        prop="picture">
            <el-upload class="upload-demo"
                       :action="fileloadUrl"
                       accept=""
                       :on-success="handlePdfPreview"
                       multiple
                       :limit="3"
                       :file-list="filePdfList">
              <el-button size="small"
                         type="primary">点击上传</el-button>
              <div slot="tip"
                   class="el-upload__tip">只能上传pdf文件</div>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <div class="editor-wrap">
        <VueEditor :content="dataForm.content_text"
                   placeholder="这个是文章内容编辑区域，如果是转载内容，请著名转载，标注好侵权及删的声明。"
                   @change="contentChange" />
      </div>
    </div>
    <SubjectChoose :visible="subjectChooseDialog"
                   :subjects="subjects"
                   @close="subjectChooseDialog = false"
                   @submit="saveSubject"></SubjectChoose>
    <MajorChoose :visible="majorChooseDialog"
                 :majors="majors"
                 @close="majorChooseDialog = false"
                 @submit="saveMajor"></MajorChoose>
    <CollegeChoose :visible="collegeChooseDialog"
                   :colleges="colleges"
                   @close="collegeChooseDialog = false"
                   @submit="saveCollege"></CollegeChoose>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%"
           :src="dialogImageUrl"
           alt="" />
    </el-dialog>
  </div>
</template>

<script>
import SubjectChoose from '@/components/dialog/subject/SubjectChoose'
import MajorChoose from '@/components/dialog/major/MajorChoose'
import CollegeChoose from '@/components/dialog/college/CollegeChoose'
import { imgUploadUrl, uploadHeaders, fileUploadUrl } from '@/config/index'
import { noteDetail, notePut } from '@/api/senior'
import UEeditor from '@/components/UEeditor'
import VueEditor from '@/components/VueEditor'

export default {
  components: {
    SubjectChoose,
    MajorChoose,
    CollegeChoose,
    UEeditor,
    VueEditor,
  },

  data() {
    var checkPicture = (rule, value, callback) => {
      if (!this.fileList || !this.fileList.length) {
        return callback(new Error('上传图片不能为空!'))
      }
      callback()
    }
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      fileList: [],
      filePdfList: [],
      subjectChooseDialog: false,
      majorChooseDialog: false,
      collegeChooseDialog: false,
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      fileloadUrl: fileUploadUrl(),
      dataForm: {
        picture_url: '',
        title: '',
        content_text: '',
        status: false,
      },
      subjects: [],
      majors: [],
      colleges: [],
      categorys: [],
      authors: [],
      rules: {
        title: [{ required: true, message: '请输入文章标题', trigger: 'blur' }],
        picture: [{ required: true, validator: checkPicture, trigger: 'blur' }],
        content_text: [
          { required: true, message: '请输入文章内容', trigger: 'blur' },
        ],
      },
    }
  },
  created() {
    this.fetchArticleInfo()
  },
  mounted() {
    this.scrollToTop()
  },
  methods: {
    handleSuccess(response, file, fileList) {
      this.fileList = fileList.map((item) => {
        if (item.response) {
          return item.response.data
        } else {
          return item
        }
      })
    },
    handleRemove(file, fileList) {
      this.fileList = fileList.map((item) => {
        if (item.response) {
          return item.response.data
        } else {
          return item
        }
      })
    },
    handlePdfPreview(file) {
      this.filePdfList.push({ url: file.data.url })
      console.log(' this.filePdfList', this.filePdfList)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    // 基本信息
    fetchArticleInfo() {
      noteDetail({ id: this.$route.params.id }).then((res) => {
        if (res) {
          this.dataForm = res
          if (res.media_img_urls) {
            this.fileList = res.media_img_urls
              .split(',')
              .map((item, index) => ({
                url: item,
                name: 'image' + index,
              }))
          }
          if (this.dataForm.topic_subject_code) {
            this.dataForm.topic_subject_code.split(',').map((item) => {
              this.dataForm.topic_subject_name.split(',').map((v) => {
                this.subjects.push({
                  code: item,
                  name: v,
                })
              })
            })
          }
          if (this.dataForm.topic_college_code) {
            this.dataForm.topic_college_code.split(',').map((item) => {
              this.dataForm.topic_college_name.split(',').map((v) => {
                this.colleges.push({
                  code: item,
                  name: v,
                })
              })
            })
          }
          if (this.dataForm.topic_major_code) {
            this.dataForm.topic_major_code.split(',').map((item) => {
              this.dataForm.topic_major_name.split(',').map((v) => {
                this.majors.push({
                  code: item,
                  name: v,
                })
              })
            })
          }

          if (this.dataForm.extend_pdf_urls != '') {
            this.dataForm.extend_pdf_urls.split(',').map((item) => {
              this.filePdfList.push({
                url: item,
              })
            })
            console.log('this.filePdfList', this.filePdfList)
          }
        }
      })
    },
    scrollToTop() {
      // Chrome
      document.body.scrollTop = 0
      // Firefox
      document.documentElement.scrollTop = 0
      // Safari
      window.pageYOffset = 0
    },
    handleSubjectClose(item) {
      console.log(item)
    },
    handleSubjectRemove(item) {
      this.subjects = this.subjects.filter((v) => v.id !== item.id)
    },
    handleSubjectChoose() {
      this.subjectChooseDialog = true
    },
    saveSubject({ subjects }) {
      this.subjects = subjects
    },
    handleMajorRemove(item) {
      this.majors = this.majors.filter((v) => v.id !== item.id)
    },
    handleMajorChoose() {
      this.majorChooseDialog = true
    },
    saveMajor({ majors }) {
      this.majors = majors
    },
    handleCollegeRemove(item) {
      this.colleges = this.colleges.filter((v) => v.id !== item.id)
    },
    handleCollegeChoose() {
      this.collegeChooseDialog = true
    },
    saveCollege({ colleges }) {
      this.colleges = colleges
    },
    handleUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.dataForm.picture_url = res.data.url
      } else {
        this.$message.error(res.error)
      }
    },
    handleBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 5

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 5MB!')
      }
      return isLt2M
    },
    initDtaForm(e) {
      this.dataForm.content_text = e
    },
    handleSubmit() {
      let pdfList = []
      if (this.filePdfList.length > 0) {
        this.filePdfList.map((item) => {
          pdfList.push(item.url)
        })
      }

      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let picture_url = this.fileList.map((item) => item.url).join(',')
          if (!this.dataForm.content_text) {
            return this.$message.error(`请输入文章内容`)
          }

          let params = {
            id: this.dataForm.id,
            uid: this.dataForm.author_user_obj.id,
            title: this.dataForm.title,
            content_text: this.dataForm.content_text,
            topic_college_code:
              this.colleges.length > 0
                ? this.colleges.map((item) => item.code).join(',')
                : '',
            topic_college_name:
              this.colleges.length > 0
                ? this.colleges.map((item) => item.name).join(',')
                : '',
            topic_major_code:
              this.majors.length > 0
                ? this.majors.map((item) => item.code).join(',')
                : '',
            topic_major_name:
              this.majors.length > 0
                ? this.majors.map((item) => item.name).join(',')
                : '',
            topic_subject_code:
              this.subjects.length > 0
                ? this.subjects.map((item) => item.code).join(',')
                : '',
            topic_subject_name:
              this.subjects.length > 0
                ? this.subjects.map((item) => item.name).join(',')
                : '',
            media_img_urls: picture_url,
            extend_pdf_urls: pdfList.join(','),
            media_type: this.dataForm.media_type,
          }

          notePut(params)
            .then((res) => {
              this.$message.success(`更新成功`)
              this.$refs['dataForm'].resetFields()
              this.$router.go(-1)
            })
            .catch((error) => {
              console.log('error: ', error)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$router.go(-1)
    },
    contentChange(e) {
      console.log(e)
      this.dataForm.content = e.html
    },
  },
}
</script>

<style scoped lang="less">
.experience-create {
  .header {
    background: #fff;
    padding: 20px;

    .breadcrumb {
      margin-bottom: 20px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .main {
    background: #fff;
    padding: 20px;
    margin-top: 10px;

    .title {
      font-size: 32px;
      font-weight: bold;
    }
  }
  .main .content {
    display: flex;
    margin-top: 20px;

    .left,
    .right {
      flex: 1;
    }
    .left {
      padding-right: 20px;
    }
    .form-item-wrap {
      display: flex;

      /deep/ .el-input {
        width: 150px;
      }
    }
    .upload-button {
      width: 100%;

      /deep/ .el-upload {
        width: 100%;
      }
      /deep/ .el-upload-dragger {
        width: 100%;
        height: 220px;
      }
      .el-upload-tip {
        font-size: 12px;
        color: #606266;
        margin-top: 7px;
      }
      .upload-text {
        margin-bottom: 10px;

        /*      &:before {
          content: "*";
          color: #f56c6c;
          margin-right: 4px;
        } */
      }
    }
    .tag-wrap {
      display: flex;
      flex-wrap: wrap;
    }
    .subject-item {
      margin-right: 5px;
      margin-bottom: 5px;
    }
  }
  .editor-wrap {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
    margin-top: 20px;
  }
}
</style>
